import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Meta, Title } from '@angular/platform-browser';
import { SeoPageConfig } from './types/common.types';

@Injectable({
  providedIn: 'root'
})
export class SeoService {

  #meta = inject(Meta);

  #title = inject(Title);

  constructor() { }

  setUpSEOTags(config: SeoPageConfig) {

    if (!config) return;

    const { baseTitle, baseURL, type } = environment.config.seo;
    const title = `${config.title} | ${baseTitle}`;

    // Page title
    this.#title.setTitle(title);

    // Open Graph for social networks:
    this.#meta.addTag({ property: 'og:title', content: title });
    this.#meta.addTag({ property: 'og:url', content: `${baseURL}${config.url}` });
    this.#meta.addTag({ property: 'og:type', content: type });
  }
}
